<!-- No, don't do `title | translate` or `content | translate` here. Translate the text before passing it to this control -->
@if (title) {
  <h2 mat-dialog-title><b>{{title}}</b></h2>
}
<mat-dialog-content [innerHTML]="content"></mat-dialog-content>
<mat-dialog-actions style="justify-content: end; border-top:outset">
  <button mat-stroked-button type="button" (click)="cancel()">{{'cancel' | translate  }}</button>
  <button mat-flat-button color="primary" type="button" (click)="confirm()">{{'confirm' | translate}}</button>

</mat-dialog-actions>
